import React from 'react'
// import SubzeroCryo from '../components/SubzeroCryo'
import Banner from '../components/Banner'
import { useTranslation } from 'react-i18next'
import Video from '../assets/cryoMassage.mp4'
import WhyChooseUs from '../components/WhyChooseUs'
import IntroductionSection from '../components/IntroductionSection'

const About = () => {
  const { t } = useTranslation();
  return (
    <div>
        {/* <SubzeroCryo/> */}
        <Banner videoSrc={Video} title={t('BannerTitleAbout')} bannerInfo={t('elevateWellnessJourney')} buttonText={t('bookAppointent')} />
        <IntroductionSection/>
        <WhyChooseUs/>
    </div>
  )
}

export default About